import React, { useState, useEffect } from "react";
import "../css/splash2.css";
import axios from "axios";
import logo from "../assets/logo.avif"; 
import Boot from "../components/Boot";
import banner from "../assets/default_banner.png"; 
import ContactDialog from "../components/ContactDialog"
import ShareTray from "../components/ShareTray"
// Default Metadata for fallback
const DEFAULT_METADATA = {
  bio: "Appopener",
  truncatedBio: "Default truncated bio",
  channelName: "appø",
  banner: banner,
  avatar: logo,
  channelLink: "https://www.youtube.com/@creatorcosmos",
  links: [],
};

const UserProfile = (props) => {
  const videoId = props.video_id;
  const [showPopup, setShowPopup] = useState(false);
  const [showSecondPopup, setShowSecondPopup] = useState(false);
  const [showThirdPopup, setShowThirdPopup] = useState(false);

  const [data, setChannelData] = useState(DEFAULT_METADATA);
  const [loading, setloading] = useState(false);
  const [completed, setcompleted] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [shareTrayOpen, setShareTrayOpen] = useState(false);

  const handleSubscribeClick = () => {
    window.location.href = data.channelLink;
  };

  const handleBootClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setShowSecondPopup(false);
  };

  const showSecondPopupHandler = () => {
    setShowSecondPopup(true);
  };

  const backToFirstPopup = () => {
    setShowSecondPopup(false);
    setShowThirdPopup(false);
  };

  const handleProfileClick = () => {
    setShowThirdPopup(true);
  };

  useEffect(() => {
    const fetchChannelData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}ytChannelDetails/?videoId=${videoId}`
        );

        // Validate and fallback to default metadata
        const fetchedData = response.data || {};
        setChannelData({
          bio: fetchedData.channelDescription || DEFAULT_METADATA.bio,
          truncatedBio:
            (fetchedData.channelDescription || DEFAULT_METADATA.bio).slice(0, 65) + "...",
          channelName: fetchedData.channelName || DEFAULT_METADATA.channelName,
          banner: fetchedData.banner || DEFAULT_METADATA.banner,
          avatar: fetchedData.avatar || DEFAULT_METADATA.avatar,
          channelLink: fetchedData.channelLink || DEFAULT_METADATA.channelLink,
          links: fetchedData.links || DEFAULT_METADATA.links,
        });

        setloading(true);
        setTimeout(() => {
          setcompleted(true);
          props.onApiDataLoaded();
        }, 0);
      } catch (error) {
        console.error("Error fetching channel data:", error);
        setChannelData(DEFAULT_METADATA);
        setloading(true);
        setTimeout(() => {
          setcompleted(true);
          props.onApiDataLoaded();
        }, 0);
      }
    };

    fetchChannelData();
  }, [videoId, props.onApiDataLoaded]);

  return (
    <>
      {!completed ? (
        <div className="full-screen-loader">
          {!loading ? (
            <div className="spinner ">
              <img src={logo} alt="AppOpener Logo" />
              <span>Please Wait...</span>
              <div className="half-spinner"></div>
            </div>
          ) : (
            <div className="completed">&#x2713;</div>
          )}
        </div>
      ) : (
        <>
          <div className="pt-1 bg-black">
            <div className="z-10 absolute top-0 w-auto left-1/2 transform -translate-x-1/2 bg-[#F5EDED] text-black px-4 py-2 rounded-b-[1.1rem]">
              <span className="font-bold text-black pb-3">{data.channelName}</span>
            </div>
          </div>

          <div className="user-profile pt-4">
            <div className="profile-header">
              <img src={data.banner} alt="Cover" className="cover-photo" />
              {data.avatar ? (
                <img src={data.avatar} alt="Profile" className="profile-pic" />
              ) : (
                <img src={logo} alt="Profile" className="profile-pic " />
              )}
              <div className="user-details">
                <div className="social-links">
                  {data.links &&
                    data.links.map((link, index) => (
                      <a
                        key={index}
                        href={`https://${link.link}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={link.favicon[0]?.url}
                          alt={`Favicon for ${link.title}`}
                        />
                      </a>
                    ))}
                </div>

                <div className="container-btn">
                 <button className="subs-btn" onClick={handleSubscribeClick}>
                    Contriii
                  </button>
                  <button className="share-btns" onClick={() => {setShareTrayOpen(true);props.onCancelRedirect(); }}>
                    Promote
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
       <ContactDialog open={dialogOpen} onOpenChange={setDialogOpen} />
       <ShareTray open={shareTrayOpen} onOpenChange={setShareTrayOpen} />

      <Boot
        show={showPopup}
        onClose={closePopup}
        onNextPopup={showSecondPopupHandler}
        onBack={backToFirstPopup}
        showSecondPopup={showSecondPopup}
        showThirdPopup={showThirdPopup}
        onProfileClick={handleProfileClick}
      />
    </>
  );
};

export default UserProfile;
